import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import API_URL from '../config/api';

const CarList = () => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCars = async () => {
      console.log('Fetching cars from:', `${API_URL}/api/cars`);
      try {
        const response = await fetch(`${API_URL}/api/cars`);
        console.log('Response status:', response.status);
        const data = await response.json();
        console.log('Received data:', data);
        if (response.ok) {
          setCars(data);
        } else {
          setError(data.message || 'Failed to fetch cars');
        }
      } catch (error) {
        console.error('Fetch error:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCars();
  }, []);

  if (loading) return (
    <div className="min-h-screen bg-gray-900 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="animate-pulse text-white">Načítání aut...</div>
      </div>
    </div>
  );

  if (error) return (
    <div className="min-h-screen bg-gray-900 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-red-500">Chyba: {error}</div>
      </div>
    </div>
  );

  return (
    <div className="bg-gray-900 py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cars.map(car => (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              key={car._id}
              className="bg-gray-800 rounded-xl overflow-hidden hover:shadow-xl 
                         transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="relative h-48">
                <img
                  src={car.images[0] || '/images/car-placeholder.jpg'}
                  alt={`${car.make} ${car.model}`}
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t 
                              from-gray-900 to-transparent h-24"/>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-2">
                  {car.make} {car.model}
                </h3>
                <div className="space-y-2 text-gray-300">
                  <p>Rok: {car.year}</p>
                  <p>Najeto: {car.mileage?.toLocaleString()} km</p>
                  <p>Motor: {car.engineCapacity}</p>
                  <p>Převodovka: {car.transmission}</p>
                </div>
                <Link 
                  to={`/car/${car._id}`}
                  className="mt-4 inline-block w-full text-center bg-gradient-to-r 
                           from-blue-600 to-purple-600 text-white px-6 py-3 rounded-lg
                           hover:from-blue-700 hover:to-purple-700 transition-all duration-300"
                >
                  Zobrazit detail
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CarList;
